import React, { useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { Controller } from "react-hook-form";

export default function TextFieldControl(props) {
  const {
    name,
    error,
    required = true,
    firstError = "",
    control,
    rules = {},
    label,
    tooltipTitle = "",
    inputProps = {},
    overrideHandlers = {},
    ...rest
  } = props;
  const inputRef = useRef();

  useEffect(() => {
    if (error && error.ref && firstError === name && inputRef.current) {
      inputRef.current.focus();
    }
  }, [error, firstError, name]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      rules={rules}
      render={({ field }) => {
        return (
          <Tooltip title={tooltipTitle} arrow>
            <TextField
              inputRef={inputRef}
              onBlur={inputRef?.current?.onBlur}
              onFocus={inputRef?.current?.onFocus}
              onChange={inputRef?.current?.onChange}
              required={required}
              fullWidth
              margin="dense"
              size="small"
              label={label}
              inputProps={inputProps}
              {...(!!error
                ? {
                    error: !!error,
                    helperText: error ? error.message : null,
                  }
                : {})}
              {...rest}
              {...field}
              {...overrideHandlers}
            />
          </Tooltip>
        );
      }}
    />
  );
}
